<div class="ts1-role-ob-counter flex shrink-0 items-center gap-1">
	<button
		type="button"
		class="attemptBtn removeBtn flex h-[24px] w-[24px] items-center justify-center rounded-lg text-sm"
		[class.opacity-50]="disableRemove"
		[disabled]="disableRemove"
		(click)="remove()"
	>
		-
	</button>
	<button
		type="button"
		class="attemptBtn addBtn flex h-[24px] w-[24px] items-center justify-center rounded-lg text-sm"
		[class.opacity-50]="disableAdd"
		[disabled]="disableAdd"
		(click)="add()"
	>
		+
	</button>
</div>
